import React from 'react';
import Image from '../AppImage';
import LanguageSwitcher from '../LanguageSwitcher';

const RestaurantHeader = ({
  restaurantName = 'Restaurant Name',
  restaurantLogo = '/assets/images/restaurant-logo.png',
  tagline = 'Culinary Excellence',
  className = ''
}) => {
  return (
    <header className={`restaurant-header sticky top-0 z-nav bg-card shadow-warm transition-smooth ${className}`}>
      <div className="container mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 lg:h-24">
          <div className="flex items-center space-x-4">
            <div className="restaurant-logo-container flex-shrink-0">
              <Image
                src={restaurantLogo || '/assets/images/logo_restaurant1-1789147807041.jpg'}
                alt={`${restaurantName} logo`}
                className="restaurant-logo h-12 w-12 lg:h-16 lg:w-16 rounded-lg object-cover shadow-warm-sm transition-smooth hover:shadow-warm" />
            </div>
            <div className="restaurant-brand-text">
              <h1 className="text-xl lg:text-2xl font-heading font-semibold text-foreground leading-tight">
                {restaurantName}
              </h1>
              {tagline &&
                <p className="text-sm lg:text-base font-caption text-muted-foreground mt-0.5">
                  {tagline}
                </p>
              }
            </div>
          </div>
          <div className="flex items-center">
            <LanguageSwitcher />
          </div>
        </div>
      </div>
    </header>
  );
};

export default RestaurantHeader;